import * as React from 'react';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { IMantleCtaButton } from '~domain/entities/Node';

function stylingCta(props: ICtaStyle) {
    if (props.color_vals) {
        return `${props.bgcolor} ${props.textcolor} ${props.bordercolor}`;
    }

    return null;
}

interface IStyledCtaButton {
    theme: ICtaStyle;
}

const CtaButtonLink = styled.a`
    ${(props: { theme: ICtaStyle }) => stylingCta(props.theme)}
`;

const CtaButton = styled.div`
    ${(props: { theme: ICtaStyle }) => stylingCta(props.theme)}
`;

interface ICtaButton extends IMantleCtaButton {
    className?: string;
    onClick?(): void;
    cta_button_id?: string;
}

interface ICtaWrapperProps {
    className: string;
    title: string;
    theme: ICtaStyle;
    'data-trigger-type': string;
    onClick?(): void;
    href?: string;
    target?: string;
    id?: string;
}

interface ICtaStyle {
    color_vals: boolean;
    bgcolor: string;
    textcolor: string;
    bordercolor: string;
}

export const MantleCtaButton = observer((props: ICtaButton) => {
    const {
        href,
        text,
        classname,
        color_vals,
        bgcolor,
        textcolor,
        bordercolor,
        trigger_type,
        open_new_window,
        cta_button_id,
        className,
        onClick
    } = props;

    if (!text) {
        return null;
    }

    const ctaClassName = classnames(
        'elc-media-asset',
        'js-media-asset',
        'js-mantle-cta-button',
        'button',
        classname
    );

    const CtaWrapper: React.ComponentType<IStyledCtaButton> = props.onClick
        ? CtaButton
        : CtaButtonLink;

    const ctaWrapperProps: ICtaWrapperProps = {
        className: ctaClassName,
        title: text,
        theme: { color_vals, bgcolor, textcolor, bordercolor },
        'data-trigger-type': trigger_type
    };

    if (onClick) {
        ctaWrapperProps.onClick = onClick;
    } else {
        ctaWrapperProps.href = href;
        ctaWrapperProps.target = open_new_window ? '_blank' : '_self';
    }

    if (cta_button_id) {
        ctaWrapperProps.id = cta_button_id;
    }

    return (
        <div className={className}>
            <CtaWrapper {...ctaWrapperProps}>
                <span>{text}</span>
            </CtaWrapper>
        </div>
    );
});
